<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col md="6" cols="12">
        <v-layout justify-center style="flex-wrap: wrap">
          <v-btn v-if="!createdCdp" small @click="createCdx('+')" color="green">{{ $t("create_cdp") }}</v-btn>
        </v-layout>
        <DataTables @editCdx="editCdx" @deleteCdx="deleteCdx" @deleteLine="deleteLine" :headers="headers"
          :tableData="tableDataCdp"></DataTables>
      </v-col>
      <v-col md="6" cols="12">
        <v-layout justify-center style="flex-wrap: wrap">
          <v-btn v-if="!createdCdc" small @click="createCdx('-')" color="red">{{
            $t("create_cdc")
          }}</v-btn>
        </v-layout>
        <DataTables @editCdx="editCdx" @deleteLine="deleteLine" @deleteCdx="deleteCdx" :headers="headers"
          :tableData="tableDataCdc"></DataTables>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import Swal from "sweetalert2";

export default {
  name: "list-cdx",
  components: {
    DataTables,
  },
  data() {
    return {
      type: null,
      cdxId: null,
      method: null,
      createdCdc: false,
      createdCdp: false,
      headers: [
        { text: this.$t("type"), value: "typeIcon", type: "icons" },
        { text: this.$t("code"), value: "cdxId" },
        { text: this.$t("text"), value: "descr", type: "editableText" },
        {
          text: this.$t("options"),
          value: "options",
          type: "buttons",
        },
      ],
      tableDataCdp: [],
      tableDataCdc: [],
    };
  },

  methods: {
    emitUpdated: function (data) {
      this.loadTable();
    },
    deleteLine(parms) {
      if (parms.callParms.type === "+") {
        this.tableDataCdp.shift();
        this.createdCdp = false;
      } else {
        this.tableDataCdc.shift();
        this.createdCdc = false;
      }
    },
    createCdx(type) {
      if (type === "+") {
        this.createdCdp = true;
        this.tableDataCdp.unshift({
          type: type,
          descr: {
            activeEdit: true,
            value: "",
            function: "editCdx",
          },
          options: [
            {
              icon: "mdi-delete",
              color: "error",
              text: this.$t("delete"),
              function: "deleteLine",
              parms: { type: type },
            },
          ],
        });
      } else {
        this.createdCdc = true;
        this.tableDataCdc.unshift({
          type: type,
          descr: {
            activeEdit: true,
            value: "",
            function: "editCdx",
            parms: { type: type },
          },
          options: [
            {
              icon: "mdi-delete",
              color: "error",
              text: this.$t("delete"),
              function: "deleteLine",
            },
          ],
        });
      }
    },

    editCdx(item) {
      let updObj = {
        type: item.type,
        cdxId: item.cdxId,
        descr: item.descr.value,
      };
      let _ = this;
      let url = "/auth/contab/updateCdx/" + item.type + "/" + item.cdxId;
      let operaz = "POST";
      if (!item.cdxId) {
        url = "/auth/contab/createCdx/" + item.type;
        operaz = "PUT";
      }
      _.chiamataAxios(operaz, url, { body: updObj }).then((response) => {
        if (response.msg.esito) {
          let html = "<strong>" + response.msg.msgTxt + "</strong>"
          Swal.fire({
            type: "success",
            html: html,
          });
          _.loadTable();
        }
      });
    },

    deleteCdx(item) {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        customClass: "v-application",
        showCancelButton: true,
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios(
            "DELETE",
            "/auth/contab/deleteCdx/" + item.type + "/" + item.cdxId
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadTable();
            }
          });
        }
      });
    },
    loadTable() {
      let _ = this;
      _.tableDataCdp = [];
      _.tableDataCdc = [];
      _.isFetching = true;
      _.createdCdp = false;
      _.createdCdc = false;
      this.chiamataAxios("GET", "/auth/contab/listCdx").then((response) => {
        _.tableDataCdc = response.data.cdc.map(function (item) {
          item.type = "-";
          item.descr = {
            activeEdit: false,
            value: item.descr,
            function: "editCdx",
          };
          item.options = [
            {
              icon: "mdi-delete",
              color: "error",
              text: _.$t("delete"),
              function: "deleteCdx",
            },
          ];
          item.typeIcon = [
            {
              icon: "mdi-minus",
              color: "red",
              text: _.$t("cdc"),
            },
          ];
          return item;
        });
        _.tableDataCdp = response.data.cdp.map(function (item) {
          item.type = "+";
          item.descr = {
            activeEdit: false,
            value: item.descr,
            function: "editCdx",
          };
          item.options = [
            {
              icon: "mdi-delete",
              color: "error",
              text: _.$t("delete"),
              function: "deleteCdx",
            },
          ];
          item.typeIcon = [
            {
              icon: "mdi-plus",
              color: "green",
              text: _.$t("cdp"),
            },
          ];
          return item;
        });
        _.isFetching = false;
      });
    },
  },
  mounted() {
    this.loadTable();
  },
};
</script>